export default {
  id: 'TeacherPage',
  code: 'CN',
  text: {
    'Search Teacher': '搜索老师名称',
    'Please exit all classes in order to archived teacher': '请您先在班级中退班，才能转为历史老师',
    'Sort by': '排序',
    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
    'Name: A-Z': '按名称：由A到Z',
    'Name: Z-A': '按名称：由Z到A',
    'Current': '当期老师',
    'Archived': '历史老师',
    'Archive Teacher': '转为历史老师',
    'Proceed to archive teacher?': '确认要转为历史老师？',
    'New Teacher': '新增老师'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/locale.js